import React from 'react';
import { motion } from 'framer-motion';

const SectionHeading = ({ 
  title, 
  subtitle, 
  centered = true, 
  light = false 
}) => {
  return (
    <div className={`max-w-3xl ${centered ? 'mx-auto text-center' : ''} mb-16`}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <h2 className={`section-title ${centered ? 'mx-auto' : ''} ${light ? 'text-white' : ''}`}>
          {title}
        </h2>
        <p className={`section-subtitle ${light ? 'text-gray-300' : ''}`}>
          {subtitle}
        </p>
      </motion.div>
    </div>
  );
}

export default SectionHeading;
